module.exports = __webpack_public_path__ + "static/media/2.74507068.png";